import { useEffect, useState } from 'react';

import {
  GOOGLE_SSO_MESSAGE_SOURCE,
  type GoogleSsoMessage,
} from '../../utils/googleIdentity';

/**
 * Public OAuth redirect target for Google popup SSO.
 * Reads the ID token from the URL fragment and postMessages it to the opener.
 */
const GoogleCallback = () => {
  const [status, setStatus] = useState('Completing Google sign-in…');

  useEffect(() => {
    const params = new URLSearchParams(
      window.location.hash.replace(/^#/, '') || window.location.search.replace(/^\?/, '')
    );
    const idToken = params.get('id_token') ?? undefined;
    const error = params.get('error') ?? undefined;
    const state = params.get('state') ?? undefined;

    const message: GoogleSsoMessage = {
      source: GOOGLE_SSO_MESSAGE_SOURCE,
      state,
      idToken,
      error: error || (!idToken ? 'missing_id_token' : undefined),
    };

    const opener = window.opener as Window | null;
    if (opener && opener !== window) {
      try {
        opener.postMessage(message, window.location.origin);
        setStatus('You can close this window.');
        window.close();
        return;
      } catch {
        setStatus('Could not return to the sign-in page. Please close this window and try again.');
        return;
      }
    }

    setStatus('Open this page from Google sign-in on the login screen.');
  }, []);

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif',
        color: '#333',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <p>{status}</p>
    </main>
  );
};

export default GoogleCallback;
